import { useQuery } from '@tanstack/react-query';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import { QueryKeys } from '~/services/loyalty/constants';
import type { LoyaltyApiError, VouchersResponse } from '~/lib/data-contract/loyalty';
import type { AllowedOptions } from '../allowedQueryOptions';
import { useLoyaltyContext } from '..';

export const useActiveVouchers = <TData = VouchersResponse>(
    options?: AllowedOptions<VouchersResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<VouchersResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.ACTIVE_VOUCHERS],
        queryFn: createLoyaltyQuery('GetActiveVouchers', translate, trackError, {
            memberId: businessCentralId,
        }),
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
